﻿import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import App from './App.vue'
import './style.css'
import pushNotificationService from './services/pushNotificationService'
import { ensureCandlestickDataSanitized } from './utils/echartsKlineConfig'

// 确保全局 ECharts 蜡烛图对 null 占位项具有防御能力
ensureCandlestickDataSanitized()


const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(ElementPlus)
app.use(Vant)

app.mount('#app')

// 中文注释：仅在支持 PWA 的浏览器中静默注册 Service Worker；订阅权限仍由用户显式触发。
if ('serviceWorker' in navigator) {
  pushNotificationService.initialize().catch((error) => {
    console.warn('PWA 初始化失败:', error)
  })
}
